import { call, put, takeEvery } from "redux-saga/effects";

import {
  GET_ALL_ORG_NEWRELIC_RESOURCE_TYPES,
  GET_DEFAULT_THRESHOLDS_NEWRELIC_RESOURCE_BY_ID,
  GET_NEWRELIC_ALERTS,
  GET_NEWRELIC_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID,
  GET_NEWRELIC_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID,
  DEPLOY_NEW_RELIC_DYNAMIC_ALERTS_BY_RESOURCE_ID,
  GET_NEWRELIC_ALL_RESOURCE_ALERTS,
  GET_NEWRELIC_ALL_RESOURCE_ALERTS_PAGE,
  GET_NEWRELIC_RESOURCE_BY_ID,
  POST_NEW_RELIC_DISABLE_ALERTS,
  POST_NEW_RELIC_ENABLE_ALERTS,
  POST_NEW_RELIC_RESOURCE_OPSGENIE_TEAM_MAPPING,
  POST_NEW_RELIC_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
  POST_NEW_RELIC_SERVICE_MAPPING,
  POST_UPDATE_NEWRELIC_RESOURCE_ENVIRONMENT,
  GET_NEWRELIC_ALL_RESOURCE_COUNT,
  POST_NEWRELIC_MARK_TRANSACTION_AS_KEY_TRANSACTION,
  POST_NEWRELIC_DELETE_KEY_TRANSACTION,
  GET_NEWRELIC_TRANSACTIONS_BY_APM,
  GET_NEWRELIC_EXTERNAL_SERVICES,
  GET_NEWRELIC_EXTERNAL_SERVICES_RESOURCE_COUNT,
  GET_USER_RESCAN_STATUS_NEWRELIC
} from "./actionTypes";

import {
  getAllOrgNewRelicResourceTypesFail,
  getAllOrgNewRelicResourceTypesSuccess,
  getDefaultThresholdsNRResourceByResourceIDFail,
  getDefaultThresholdsNRResourceByResourceIDSuccess,
  getNewRelicDynamicAlertsDeployedByResourceIDFail,
  getNewRelicDynamicAlertsDeployedByResourceIDSuccess,
  getNewRelicMissingDynamicAlertsByResourceIDFail,
  getNewRelicMissingDynamicAlertsByResourceIDSuccess,
  deployNewRelicDynamicAlertsByResourceIDFail,
  deployNewRelicDynamicAlertsByResourceIDSuccess,
  getNewRelicAlertsFail,
  getNewRelicAlertsSuccess,
  getNewRelicAllResourceAlertsFail,
  getNewRelicAllResourceAlertsPageFail,
  getNewRelicAllResourceAlertsPageSuccess,
  getNewRelicAllResourceAlertsSuccess,
  getNRResourceByResourceIDFail,
  getNRResourceByResourceIDSuccess,
  onPostNewRelicResourceOpsgenieTeamMappingFail,
  onPostNewRelicResourceOpsgenieTeamMappingSuccess,
  onPostNewRelicResourcePagerdutyServiceMappingFail,
  onPostNewRelicResourcePagerdutyServiceMappingSuccess,
  postNewRelicDisableAlertsFail, postNewRelicDisableAlertsSuccess,
  postNewRelicEnableAlertsFail, postNewRelicEnableAlertsSuccess,
  postNewRelicServiceMappingFail,
  postNewRelicServiceMappingSuccess,
  postUpdateNewRelicResourceEnvironmentFail,
  postUpdateNewRelicResourceEnvironmentSuccess,
  getNewRelicResourceCountSuccess, getNewRelicResourceCountFail,
  onPostNewRelicTransactionAsKeyTransactionSuccess, onPostNewRelicTransactionAsKeyTransactionFail,
  onPostNewRelicDeleteKeyTransactionSuccess, onPostNewRelicDeleteKeyTransactionFail,
  onGetNewRelicTransactionByAPMSuccess, onGetNewRelicTransactionByAPMFail,
  getNewRelicExternalServices,
  getNewRelicExternalServicesSuccess,
  getNewRelicExternalServicesFail,
  getNewRelicExternalServicesResourceCountSuccess,
  getNewRelicExternalServicesResourceCountFail, getNewRelicRefreshScanStatusSuccess, getNewRelicRefreshScanStatusFail
} from "./actions";

import {
  getAllOrgNewRelicResourceTypesUrl,
  getDefaultThresholdsNewRelicResourceByIDUrl,
  getNewRelicAlertsUrl,
  getNewRelicAllResourceAlertsPageUrl,
  getNewRelicAllResourceAlertsUrl,
  getNewRelicResourceByIDUrl,
  postNewRelicDisableAlertUrl,
  postNewRelicEnableAlertUrl,
  postNewRelicResourceOpsgenieTeamMapping,
  postNewRelicResourcePagerdutyServiceMappingCall,
  postNewRelicServiceMappingUrl,
  postUpdateNewRelicResourceEnvironmentUrl,
  getNewRelicAllResourceCountUrl,
  getNewRelicDynamicAlertsDeployedByResourceId,
  getNewRelicDynamicAlertsMissingByResourceId,
  deployNewRelicDynamicAlertsByResourceIdUrl,
  postMarkTransactionAsKeyTransactionUrl,
  postDeleteKeyTransactionUrl,
  getTransactionsByAPMUrl,
  getNewRelicAllExternalServicesResourceAlertsPageUrl,
  getNewRelicAllExternalServicesResourceCountUrl,  getRescanStatusNewRelicUrl
} from "../../helpers/fakebackend_helper";
import { data } from "autoprefixer";
import { showNotification } from "components/Common/notification";
import { Link } from "react-router-dom";

function* onGetNewRelicAllResourceAlerts() {
  try {
    const response = yield call(getNewRelicAllResourceAlertsUrl);
    yield put(getNewRelicAllResourceAlertsSuccess(response));
  } catch (error) {
    yield put(getNewRelicAllResourceAlertsFail(error.message));
  }
}

function* onGetNewRelicResourceByID(monitored_resource_id) {
  try {
    const response = yield call(getNewRelicResourceByIDUrl, monitored_resource_id.payload);
    yield put(getNRResourceByResourceIDSuccess(response));
  } catch (error) {
    yield put(getNRResourceByResourceIDFail(error.message));
  }
}

function* onGetDefaultThresholdsNewRelicResourceByID(monitored_resource_id) {
  try {
    const response = yield call(getDefaultThresholdsNewRelicResourceByIDUrl, monitored_resource_id.payload);
    yield put(getDefaultThresholdsNRResourceByResourceIDSuccess(response));
  } catch (error) {
    yield put(getDefaultThresholdsNRResourceByResourceIDFail(error.message));
  }
}

function* onPostNewRelicResourceOpsgenieTeamMapping({ payload: { newrelic_resource_team_mapping } }) {
  try {
    const response = yield call(postNewRelicResourceOpsgenieTeamMapping, newrelic_resource_team_mapping);
    yield put(onPostNewRelicResourceOpsgenieTeamMappingSuccess(response));
  } catch (error) {
    yield put(onPostNewRelicResourceOpsgenieTeamMappingFail(error.message));
  }
}

function* onPostNewRelicResourcePagerdutyServiceMapping({ payload: { newrelic_resource_pagerduty_mapping } }) {
  try {
    const response = yield call(postNewRelicResourcePagerdutyServiceMappingCall, newrelic_resource_pagerduty_mapping);
    yield put(onPostNewRelicResourcePagerdutyServiceMappingSuccess(response));
  } catch (error) {
    yield put(onPostNewRelicResourcePagerdutyServiceMappingFail(error.message));
  }
}

function* onPostNewRelicServiceMapping({ payload: { service_mapping } }) {
  try {
    const response = yield call(postNewRelicServiceMappingUrl, service_mapping);
    yield put(postNewRelicServiceMappingSuccess(response));
    window.location.reload()
  } catch (error) {
    yield put(postNewRelicServiceMappingFail(error.message));
  }
}

function* onPostNewRelicUpdateResourceEnvironment({ payload: { resource_environment } }) {
  try {
    const response = yield call(postUpdateNewRelicResourceEnvironmentUrl, resource_environment);
    yield put(postUpdateNewRelicResourceEnvironmentSuccess(response));
  } catch (error) {
    yield put(postUpdateNewRelicResourceEnvironmentFail(error.message));
  }
}

function* onGetNewRelicAllResourceAlertsPage({ payload: { page_filters } }) {
  try {
    const response = yield call(getNewRelicAllResourceAlertsPageUrl, page_filters);
    yield put(getNewRelicAllResourceAlertsPageSuccess(response));
  } catch (error) {
    yield put(getNewRelicAllResourceAlertsPageFail(error.message));
  }
}

function* onGetNewRelicExternalServices({ payload: { page_filters } }) {
    try {
    const response = yield call(getNewRelicAllExternalServicesResourceAlertsPageUrl, page_filters);
    yield put(getNewRelicExternalServicesSuccess(response));
  } catch (error) {
      yield put(getNewRelicExternalServicesFail(error.message));
    }
}

function* onGetNewRelicAllResourceCount({ payload: { page_filters } }) {
  try {
    const response = yield call(getNewRelicAllResourceCountUrl, page_filters);
    yield put(getNewRelicResourceCountSuccess(response));
  } catch (error) {
    yield put(getNewRelicResourceCountFail(error.message));
  }
}

function* onGetNewRelicExternalServicesResourceCount({ payload: { page_filters } }) {
    try {
    const response = yield call(getNewRelicAllExternalServicesResourceCountUrl, page_filters);
    yield put(getNewRelicExternalServicesResourceCountSuccess(response));
  } catch (error) {
      yield put(getNewRelicExternalServicesResourceCountFail(error.message));
    }
}

function* onGetAllOrgNewRelicResourceTypes() {
  try {
    const response = yield call(getAllOrgNewRelicResourceTypesUrl);
    yield put(getAllOrgNewRelicResourceTypesSuccess(response));
  } catch (error) {
    yield put(getAllOrgNewRelicResourceTypesFail(error.message));
  }
}

function* onPostNewRelicDisableAlerts({ payload: { alerts } }) {
  try {
    const response = yield call(postNewRelicDisableAlertUrl, alerts);
    yield put(postNewRelicDisableAlertsSuccess(response));
    showNotification("success", 'Disable alert request queued successfully');
    window.location.reload()
  } catch (error) {
    yield put(postNewRelicDisableAlertsFail(error.message));
  }
}

function* onPostNewRelicEnableAlerts({ payload: { alerts } }) {
  try {
    const response = yield call(postNewRelicEnableAlertUrl, alerts);
    yield put(postNewRelicEnableAlertsSuccess(response));
    showNotification("success", 'Enable alert request queued successfully');
    window.location.reload()
  } catch (error) {
    yield put(postNewRelicEnableAlertsFail(error.message));
  }
}

function* onGetNewRelicAlerts(monitored_resource_id) {
  try {
    const response = yield call(getNewRelicAlertsUrl, monitored_resource_id.payload);
    let final_response = {}
    final_response[monitored_resource_id.payload] = response;
    yield put(getNewRelicAlertsSuccess(final_response));
  } catch (error) {
    yield put(getNewRelicAlertsFail(error.message));
  }
}

function* onGetNewRelicDynamicAlertsDeployedByResourceID(monitored_resource_id) {
  try {
    const response = yield call(getNewRelicDynamicAlertsDeployedByResourceId, { monitored_resource_id: monitored_resource_id.payload });
    yield put(getNewRelicDynamicAlertsDeployedByResourceIDSuccess(response));
  } catch (error) {
    yield put(getNewRelicDynamicAlertsDeployedByResourceIDFail(error.message));
  }
}

function* onGetNewRelicMissingDynamicAlertsByResourceID(monitored_resource_id) {
  try {
    const response = yield call(getNewRelicDynamicAlertsMissingByResourceId, { monitored_resource_id: monitored_resource_id.payload });
    yield put(getNewRelicMissingDynamicAlertsByResourceIDSuccess(response));
  } catch (error) {
    yield put(getNewRelicMissingDynamicAlertsByResourceIDFail(error.message));
  }
}

function* onDeployNewRelicDynamicAlertsByResourceID(data) {
  try {
    const response = yield call(deployNewRelicDynamicAlertsByResourceIdUrl, data.payload);
    yield put(deployNewRelicDynamicAlertsByResourceIDSuccess(response));

    setTimeout(() => {
      window.location.reload();
    }, 1000);
  } catch (error) {
    yield put(deployNewRelicDynamicAlertsByResourceIDFail(error.message));
  }
}

function* onPostTransactionAsKeyTransaction(payload){
  try{
    const response = yield call(postMarkTransactionAsKeyTransactionUrl, payload.payload)
    yield put(onPostNewRelicTransactionAsKeyTransactionSuccess(response));
    window.location.href = '/new-relic-resources';
  } catch (error) {
    yield put(onPostNewRelicTransactionAsKeyTransactionFail(error.message))
  }
}

function* onPostNewRelicDeleteKeyTransaction(payload){
  try{
    const response = yield call(postDeleteKeyTransactionUrl, payload.payload)
    yield put(onPostNewRelicDeleteKeyTransactionSuccess(response));
    window.location.href = '/new-relic-resources';
  } catch (error) {
    yield put(onPostNewRelicDeleteKeyTransactionFail(error.message))
  }
}

function* onGetNewRelicTransactionByAPM( {payload: { page_filters }}){
  try{
    const response = yield call(getTransactionsByAPMUrl, page_filters)
    yield put(onGetNewRelicTransactionByAPMSuccess(response));
  } catch (error) {
    yield put(onGetNewRelicTransactionByAPMFail(error.message))
  }
}

function* onGetNewRelicRescanStatus() {
  try {
    const response = yield call(getRescanStatusNewRelicUrl);
    yield put(getNewRelicRefreshScanStatusSuccess(response));
  } catch (error) {
    yield put(getNewRelicRefreshScanStatusFail(error.message));
  }
}


function* newRelicSaga() {
  yield takeEvery(GET_NEWRELIC_ALL_RESOURCE_ALERTS, onGetNewRelicAllResourceAlerts);
  yield takeEvery(GET_NEWRELIC_RESOURCE_BY_ID, onGetNewRelicResourceByID);
  yield takeEvery(GET_DEFAULT_THRESHOLDS_NEWRELIC_RESOURCE_BY_ID, onGetDefaultThresholdsNewRelicResourceByID);
  yield takeEvery(GET_NEWRELIC_ALL_RESOURCE_ALERTS_PAGE, onGetNewRelicAllResourceAlertsPage);
  yield takeEvery(GET_NEWRELIC_ALL_RESOURCE_COUNT, onGetNewRelicAllResourceCount);
  yield takeEvery(GET_ALL_ORG_NEWRELIC_RESOURCE_TYPES, onGetAllOrgNewRelicResourceTypes);
  yield takeEvery(POST_NEW_RELIC_SERVICE_MAPPING, onPostNewRelicServiceMapping);
  yield takeEvery(POST_NEW_RELIC_RESOURCE_OPSGENIE_TEAM_MAPPING, onPostNewRelicResourceOpsgenieTeamMapping);
  yield takeEvery(POST_NEW_RELIC_RESOURCE_PAGERDUTY_SERVICE_MAPPING, onPostNewRelicResourcePagerdutyServiceMapping);
  yield takeEvery(POST_UPDATE_NEWRELIC_RESOURCE_ENVIRONMENT, onPostNewRelicUpdateResourceEnvironment);
  yield takeEvery(POST_NEW_RELIC_DISABLE_ALERTS, onPostNewRelicDisableAlerts);
  yield takeEvery(POST_NEW_RELIC_ENABLE_ALERTS, onPostNewRelicEnableAlerts);
  yield takeEvery(GET_NEWRELIC_ALERTS, onGetNewRelicAlerts);
  yield takeEvery(GET_NEWRELIC_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID, onGetNewRelicDynamicAlertsDeployedByResourceID);
  yield takeEvery(GET_NEWRELIC_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID, onGetNewRelicMissingDynamicAlertsByResourceID);
  yield takeEvery(DEPLOY_NEW_RELIC_DYNAMIC_ALERTS_BY_RESOURCE_ID, onDeployNewRelicDynamicAlertsByResourceID);
  yield takeEvery(POST_NEWRELIC_MARK_TRANSACTION_AS_KEY_TRANSACTION, onPostTransactionAsKeyTransaction);
  yield takeEvery(POST_NEWRELIC_DELETE_KEY_TRANSACTION, onPostNewRelicDeleteKeyTransaction);
  yield takeEvery(GET_NEWRELIC_TRANSACTIONS_BY_APM, onGetNewRelicTransactionByAPM);
  yield takeEvery(GET_NEWRELIC_EXTERNAL_SERVICES, onGetNewRelicExternalServices);
  yield takeEvery(GET_NEWRELIC_EXTERNAL_SERVICES_RESOURCE_COUNT, onGetNewRelicExternalServicesResourceCount);
  yield takeEvery(GET_USER_RESCAN_STATUS_NEWRELIC,onGetNewRelicRescanStatus);
}

export default newRelicSaga;
